module.exports = __webpack_public_path__ + "img/farzana-christopher-76.69a8d6c8.jpg";